import { render, staticRenderFns } from "./peachReport.vue?vue&type=template&id=e1809afa&"
import script from "./peachReport.vue?vue&type=script&lang=js&"
export * from "./peachReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1809afa')) {
      api.createRecord('e1809afa', component.options)
    } else {
      api.reload('e1809afa', component.options)
    }
    module.hot.accept("./peachReport.vue?vue&type=template&id=e1809afa&", function () {
      api.rerender('e1809afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/peach-pear-plum/views/peachReport.vue"
export default component.exports